import { render } from "./index.vue?vue&type=template&id=646f0d49"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render

export default script